import React, { useEffect, useRef, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";

export default function ContactDialog({ onClose }) {
  const dialog = useRef(null);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const previousFocus = document.activeElement;
    dialog.current.showModal();
    return () => previousFocus?.focus();
  }, []);

  async function submit(event) {
    event.preventDefault();
    if (busy) return;
    const values = Object.fromEntries(new FormData(event.currentTarget));
    setBusy(true);
    setError("");
    try {
      await httpsCallable(functions, "sendContactEmail")(values);
      setSent(true);
    } catch (failure) {
      setError(failure.code === "functions/resource-exhausted"
        ? "Too many messages. Please try again in an hour."
        : "Your message could not be sent. Please try again shortly.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <dialog ref={dialog} aria-labelledby="contact-title" onCancel={onClose}
      className="rounded-lg border border-gray-300 bg-white p-0 text-gray-900 shadow-xl w-[calc(100%-2rem)] max-w-lg backdrop:bg-black/50">
      <div className="p-6">
        <div className="flex items-center justify-between gap-4 mb-3">
          <h2 id="contact-title" className="text-2xl font-bold">Contact Glastonbury Data</h2>
          <button type="button" onClick={onClose} className="btn btn-sm btn-ghost" aria-label="Close contact form">✕</button>
        </div>
        {sent ? <div role="status"><p>Thank you! Your message has been sent.</p><button className="btn btn-primary mt-4" onClick={onClose}>Done</button></div> : <>
          <p className="text-sm text-gray-600 mb-5">Have a question, spotted an error, or have an idea for the site? Send me a message.</p>
          <form onSubmit={submit} className="space-y-4">
            <label className="block text-sm font-semibold">Your name<input name="name" autoComplete="name" required maxLength={100} className="input input-bordered w-full mt-1" /></label>
            <label className="block text-sm font-semibold">Your email<input name="email" type="email" autoComplete="email" required maxLength={254} className="input input-bordered w-full mt-1" /></label>
            <label className="block text-sm font-semibold">Reason for contacting<select name="reason" required defaultValue="" className="select select-bordered w-full mt-1">
              <option value="" disabled>Select a reason</option>
              {["Question about the data", "Report an error", "Suggestion for the site", "Other"].map(reason => <option key={reason}>{reason}</option>)}
            </select></label>
            <label className="block text-sm font-semibold">Message<textarea name="message" required minLength={10} maxLength={5000} rows={5} className="textarea textarea-bordered w-full mt-1" /></label>
            <div hidden aria-hidden="true"><label>Website<input name="website" tabIndex={-1} autoComplete="off" /></label></div>
            {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
            <button type="submit" disabled={busy} className="btn btn-primary w-full">{busy ? "Sending…" : "Send message"}</button>
          </form>
        </>}
      </div>
    </dialog>
  );
}
